export default __webpack_public_path__ + "static/media/07.17d2de20.jpg";